
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRules } from "@common/src/utils/verify";
import { addCurrencyUnit } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
const marketing = namespace("marketing");
@Component({})
export default class ValueCardEdit extends Vue {
  @marketing.Action createCardTemplate;
  @marketing.Action queryCardTemplateDetail;
  @marketing.Action updateCardTemplate;
  addCurrencyUnit = addCurrencyUnit;
  valueCardForm = {
    cardTemplateName: "",
    cardAmount: "",
    giftAmount: "",
    enableStatus: 1,
    checked: true,
    usefulLife: t("marketing.permanent"),
    validPeriod: -1,
    cardDesc: "",
    cardType: 2,
    cardTemplateCode: "",
    carryingAmount: "",
    usedStatus: undefined
  };
  moneyRule = (rule, value, callback) => {
    if (priceRules(value)) {
      callback();
    } else {
      callback(new Error(t("v210831.please-enter-a-rational-amount")));
    }
  };
  valueCardRules = {
    cardTemplateName: [
      { required: true, message: t("marketing.please-input-card-name"), trigger: "blur" },
      { min: 1, max: 150, message: t("v210831.the-length-is-1-150"), trigger: "blur" }
    ],
    cardAmount: [
      { required: true, message: t("v210831.please-enter-the-recharge-amount"), trigger: "blur" },
      {
        validator: this.moneyRule
      }
    ],
    giftAmount: [
      { required: true, message: t("v210831.please-enter-the-give-amount"), trigger: "blur" },
      {
        validator: this.moneyRule
      }
    ]
  };
  //计算属性
  get computeCountMoney() {
    return Number(this.valueCardForm.cardAmount) + Number(this.valueCardForm.giftAmount);
  }
  get isAdd() {
    return this.$route.name === "ValueCardAdd";
  }
  get breadData() {
    return [
      { name: t("marketing.card-template"), path: "/marketing/card-template" },
      {
        name: this.isAdd ? t("v210831.new-stored-value-card-template") : t("v210831.edit-stored-value-card-template")
      }
    ];
  }
  created() {
    this.init();
  }

  init() {
    if (this.$route.name === "ValueCardEdit") {
      this.queryCardTemplateDetail({ cardTemplateCode: this.$route.params.id }).then(res => {
        console.log("[ res ]", res);
        this.valueCardForm.cardAmount = res.data.cardAmount;
        this.valueCardForm.cardDesc = res.data.cardDesc;
        this.valueCardForm.cardTemplateCode = res.data.cardTemplateCode;
        this.valueCardForm.cardTemplateName = res.data.cardTemplateName;
        this.valueCardForm.carryingAmount = res.data.carryingAmount;
        this.valueCardForm.enableStatus = res.data.enableStatus;
        this.valueCardForm.giftAmount = res.data.giftAmount;
        this.valueCardForm.usedStatus = res.data.usedStatus;
      });
    }
  }
  submitForm() {
    let resForm = this.$refs.valueCardForm as any;
    resForm.validate(valid => {
      if (valid) {
        if (this.$route.name === "ValueCardEdit") {
          this.updateCardTemplate(this.valueCardForm).then(() => {
            this.$message.success(t("v210831.card-template-updated"));
            this.$router.push("/marketing/card-template");
          });
        } else {
          this.createCardTemplate(this.valueCardForm).then(() => {
            this.$message.success(t("v210831.card-template-saved"));
            this.$router.push("/marketing/card-template");
          });
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
}
